module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("\n        Шаблон сценария\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "select is-primary"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentScenario),
      expression: "currentScenario"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.loadedScenario !== null
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentScenario = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.activeSelectList), function(scenario) {
    return _c('option', [_vm._v("\n            " + _vm._s(scenario.name) + "\n          ")])
  }), 0)]), _vm._v(" "), (_vm.currentScenario === _vm.selectList[0].name) ? _c('scenario-question-recognition', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[1].name) ? _c('scenario-question-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[2].name) ? _c('scenario-two-level-yes-no', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[3].name) ? _c('scenario-notice', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e(), _vm._v(" "), (_vm.currentScenario === _vm.selectList[4].name) ? _c('scenario-question-interview', {
    attrs: {
      "campaignid": _vm.campaignid,
      "name": _vm.id
    },
    on: {
      "set": _vm.setScenario
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121590ca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/Scenario.vue
// module id = 421
// module chunks = 40